document.addEventListener("DOMContentLoaded", (event) => {
	//First check if the package & bundle section exists.
	if(document.getElementById('custom-packages-bundle')) {
		//Check if the product form is accessible and have the quanitiy field in it.
		const productForm = document.querySelector('product-form')
		const subscriptionWidget = document.querySelector('.shopify_subscriptions_fieldset')
		//If the quantity field doesn't exist you must create it.
		if(!productForm.querySelector('input[name="quantity"]')) {
			const __input = document.createElement('input')
			__input.name = 'quantity'
			__input.type = 'hidden'
			__input.value = 1 //Default value should be always 1.
			productForm.querySelector('form').appendChild(__input)
		}


		const quanitiyField = productForm.querySelector('input[name="quantity"]')
		//Always make sure the value is 1 by default.
		quanitiyField.value = 1

		const packagesBundles = document.getElementById('custom-packages-bundle').querySelectorAll('.custom-packages-item input[name="pack-size"]')
		packagesBundles.forEach(package => { 
			package.addEventListener('change', () => { 
				try {
					//Change the appearance at the subscription widget.
					if(subscriptionWidget) {
						subscriptionWidget.querySelectorAll('.shopify_subscriptions_purchase_option_wrapper .shopify_subscriptions_in_widget_price')[0].innerText = package.dataset.priceFormatted
						subscriptionWidget.querySelectorAll('.shopify_subscriptions_purchase_option_wrapper .shopify_subscriptions_in_widget_price')[1].innerText = package.dataset.priceFormattedSubscription
					}
				} catch( error ) {
					console.error(error)
				}

				try {
					quanitiyField.value = Number(package.value)
				} catch( error) {
					console.error(error)
				}
			}) 
		})

		//Also when the subscription widget selected value changes the price also refreshes so have to overwrite that as well.
		subscriptionWidget.querySelectorAll('input[type="radio"]').forEach( radio => {
			radio.addEventListener('change', () => {
				//Find which package is selected.
				try {
					//Change the appearance at the subscription widget.
					if(subscriptionWidget) {
						subscriptionWidget.querySelectorAll('.shopify_subscriptions_purchase_option_wrapper .shopify_subscriptions_in_widget_price')[0].innerText = document.getElementById('custom-packages-bundle').querySelector('input[name="pack-size"]:checked').dataset.priceFormatted
						subscriptionWidget.querySelectorAll('.shopify_subscriptions_purchase_option_wrapper .shopify_subscriptions_in_widget_price')[1].innerText = document.getElementById('custom-packages-bundle').querySelector('input[name="pack-size"]:checked').dataset.priceFormattedSubscription
					}
				} catch( error ) {
					console.error(error)
				}
			})
		})


	}
});